<template>
  <div>
    <uploader
      ref="uploader"
      :fileList="fileList"
      @ResetFilelist="resetFileList($event)"
    />
    <el-button @click="handle">上传</el-button>
    <el-button @click="getdata">得到数据</el-button>
  </div>
</template>

<script>
import Uploader from "../../../components/Uploader.vue";
import { baseURL } from "@/request/request";
export default {
  components: { Uploader },
  data() {
    return {
      fileList: [],
    };
  },
  methods: {
    resetFileList(event) {
      this.fileList = event;
    },
    handle() {
      this.$refs.uploader.upload();
    },
    getdata() {
      let fileObj = {};
      fileObj.url = baseURL + "/upload/logo.png";
      this.fileList = [];
      this.fileList.push(fileObj);

      console.log(this.fileList, this.fileList[0]);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>